import React, { useState } from 'react';
import { useWeb3 } from '../../context/Web3Context';
import { shortAddress } from '../../utils/format';
import { WalletModal } from './WalletModal';
import { ACTIVE } from '../../config/networks';
import { getDefaultProvider, detectWallets } from '../../utils/wallet';
import { ButtonSpinner } from '../common/Loader';

export const ConnectWallet = () => {
  const { account, rightNetwork, switchNetwork, switching, disconnect, walletName, connect, connecting } = useWeb3();
  const [fallbackOpen, setFallbackOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const handleConnect = async () => {
    const raw = getDefaultProvider();
    if (!raw) {
      // no injected wallet → fall back to modal (shows Trust/MetaMask deep links on mobile)
      setFallbackOpen(true);
      return;
    }
    // one-click direct connect
    await connect(raw);
  };

  if (!account) {
    return (
      <>
        <button className="btn btn-primary btn-sm" onClick={handleConnect} disabled={connecting}>
          {connecting && <ButtonSpinner />}
          {connecting ? 'Connecting...' : 'Connect Wallet'}
        </button>
        <WalletModal open={fallbackOpen} onClose={() => setFallbackOpen(false)} />
      </>
    );
  }

  if (!rightNetwork) {
    return (
      <button className="network-pill wrong" onClick={switchNetwork} disabled={switching}>
        {switching ? <span className="btn-spinner" /> : <span className="dot dot-red" />}
        Switch to {ACTIVE.displayName}
      </button>
    );
  }

  return (
    <div style={{ position: 'relative' }}>
      <button className="wallet-btn" onClick={() => setMenuOpen(!menuOpen)}>
        <span className="avatar" />
        <span className="addr">{shortAddress(account)}</span>
      </button>
      {menuOpen && (
        <div
          style={{
            position: 'absolute',
            top: 'calc(100% + 8px)',
            right: 0,
            background: 'var(--bg-elevated)',
            border: '1px solid var(--border-strong)',
            borderRadius: 'var(--radius)',
            padding: 12,
            minWidth: 240,
            zIndex: 200,
            boxShadow: 'var(--shadow-lg)'
          }}
        >
          <div style={{ fontSize: 11, color: 'var(--text-tertiary)', letterSpacing: 1, textTransform: 'uppercase', marginBottom: 4 }}>
            {walletName || 'Wallet'}
          </div>
          <div style={{ fontFamily: 'var(--font-mono)', fontSize: 12, color: 'var(--text-primary)', wordBreak: 'break-all', marginBottom: 12 }}>
            {account}
          </div>
          <button
            className="btn btn-ghost btn-sm btn-full"
            onClick={() => { setMenuOpen(false); disconnect(); }}
          >
            Disconnect
          </button>
        </div>
      )}
    </div>
  );
};
